import { IconFileClock } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import StepItem from '../../stepItem/StepItem';

export const PendingAccount = () => {
    return (
        <StepItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.pending_bank_details_title"
                    defaultMessage="Add your business bank details"
                />
            }
            caption={
                <FormattedMessage
                    id="_.funding_requirements.pending_bank_details.bank_details_received"
                    defaultMessage="Thanks, we have received your bank details and are currently verifying them. This typically takes up to 1 working day and we'll notify you by email or phone once completed."
                />
            }
            action={
                <Button
                    variant="primary"
                    disabled
                    className="min-w-[124px]"
                    data-testid="pending-bank-details-button"
                >
                    <IconFileClock />
                </Button>
            }
        />
    );
};
